import { Toaster as Sonner } from 'sonner';

/**
 * App-wide toast container. Mounted once in App.tsx.
 * Call `toast.success(...)` / `toast.error(...)` from anywhere in the tree.
 */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'group bg-card text-card-foreground border border-border shadow-md rounded-md',
          description: 'text-muted-foreground',
          success: 'text-success',
          error: 'text-destructive',
        },
      }}
    />
  );
}
